<script setup>
// NOOVI: colunas de tempo de resposta/resolução por time — mesmo padrão de
// AgentLiveReportContainer.vue (summaryReports/fetchTeamSummaryReports, sem
// duplicar open/unattended que já vem de fetchTeamConversationMetric).
// Período vem do filtro global (LiveReports.vue via provide/inject).
import { inject, onMounted, watch } from 'vue';

import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';
import TeamTable from './overview/TeamTable.vue';
import {
  OVERVIEW_DATE_FILTER_KEY,
  createDefaultDateFilter,
} from '../helpers/overviewDateFilter';

const store = useStore();
const dateFilter = inject(
  OVERVIEW_DATE_FILTER_KEY,
  createDefaultDateFilter,
  true
);

const uiFlags = useMapGetter('getOverviewUIFlags');
const teamConversationMetric = useMapGetter('getTeamConversationMetric');
const teamSummaryReports = useMapGetter('summaryReports/getTeamSummaryReports');
const teams = useMapGetter('teams/getTeams');

const fetchData = () => store.dispatch('fetchTeamConversationMetric');

const { startRefetching } = useLiveRefresh(fetchData);

// Regressão: getTeamReports espera {since, until, businessHours} — mesmo bug
// de AgentLiveReportContainer.vue, corrigido junto (from/to → since/until).
const fetchTeamSummary = () => {
  store.dispatch('summaryReports/fetchTeamSummaryReports', {
    since: dateFilter.from,
    until: dateFilter.to,
    businessHours: dateFilter.businessHours,
  });
};

onMounted(() => {
  store.dispatch('teams/get');
  fetchData();
  startRefetching();
  fetchTeamSummary();
});
watch(
  () => [dateFilter.from, dateFilter.to, dateFilter.businessHours],
  fetchTeamSummary
);
</script>

<template>
  <div class="flex flex-row flex-wrap max-w-full">
    <MetricCard :header="$t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.HEADER')">
      <TeamTable
        :teams="teams"
        :team-metrics="teamConversationMetric"
        :team-summary="teamSummaryReports"
        :is-loading="uiFlags.isFetchingTeamConversationMetric"
      />
    </MetricCard>
  </div>
</template>
